import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LoginComponent } from './pages/login/login.component';
import { PushNotificationsComponent } from './pages/push-notifications/push-notifications.component';
import { RootComponent } from './pages/root/root.component';
import { WaterServiceFormComponent } from './pages/water-services/water-services-form/water-service-form.component';
import { WaterServicesListComponent } from './pages/water-services/water-services-list/water-services-list.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: RootComponent,
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'water-services',
        component: WaterServicesListComponent,
      },
      {
        path: 'water-services/:waterId',
        component: WaterServiceFormComponent,
      },
      {
        path: 'push-notifications',
        component: PushNotificationsComponent,
      },
    ],
  },
];
